var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6592 14.875H21.1592C20.6951 14.875 20.25 15.0594 19.9218 15.3876C19.5936 15.7158 19.4092 16.1609 19.4092 16.625V21C19.4092 21.4641 19.5936 21.9093 19.9218 22.2374C20.25 22.5656 20.6951 22.75 21.1592 22.75H22.9092C23.3734 22.75 23.8185 22.5656 24.1467 22.2374C24.4749 21.9093 24.6592 21.4641 24.6592 21V14.875ZM24.6592 14.875C24.6592 13.4894 24.385 12.1175 23.8523 10.8384C23.3197 9.55935 22.5391 8.39832 21.5556 7.42229C20.5722 6.44626 19.4053 5.67453 18.1222 5.15157C16.8391 4.62862 15.4652 4.3648 14.0796 4.3753C12.6941 4.3648 11.3202 4.62862 10.0371 5.15157C8.75395 5.67453 7.58704 6.44626 6.60358 7.42229C5.62012 8.39832 4.83956 9.55935 4.3069 10.8384C3.77424 12.1175 3.5 13.4894 3.5 14.875V21C3.5 21.4641 3.68437 21.9093 4.01256 22.2374C4.34075 22.5656 4.78587 22.75 5.25 22.75H7C7.46413 22.75 7.90925 22.5656 8.23744 22.2374C8.56563 21.9093 8.75 21.4641 8.75 21V16.625C8.75 16.1609 8.56563 15.7158 8.23744 15.3876C7.90925 15.0594 7.46413 14.875 7 14.875H3.5",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.59a61720112c5aefad4d590f9e9ba6a1.svg";
export { ForwardRef as ReactComponent };